<template>
    <div id="bloco-tabela-territorio-nao-enviado">
        <h1>{{ $tc('certification.messages.territory_listing') }}</h1>
        <el-table
            :data="paginacaoDataTerritoriosNaoEnviados"
            stripe
            style="width: 100%"
            v-loading="carregandoTabela"
            @sort-change="sortChangeRequest"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: 'nome', order: 'ascending' }"
        >
            <el-table-column type="expand" width="40" align="center">
                <template slot-scope="scope">
                    <el-descriptions
                        class="descricao-item-tabela"
                        :size="'mini'"
                    >
                        <el-descriptions-item
                            :label="$tc('certification.words.person', 2)"
                            v-if="
                                scope.row.representantes &&
                                scope.row.representantes.length > 1
                            "
                        >
                            <div
                                class="representantes"
                                v-for="representante in scope.row
                                    .representantes"
                                :key="representante.id"
                            >
                                <p>
                                    {{ representante.nomeRazaoSocial }}
                                    <span
                                        >({{
                                            representante.cpfCnpjDecrypt
                                        }})</span
                                    >
                                </p>
                            </div>
                        </el-descriptions-item>
                        <el-descriptions-item
                            class="has-colon-not"
                            :label="
                                $tc(
                                    'certification.messages.territory_has_no_additional_people'
                                )
                            "
                            v-if="
                                scope.row.representantes &&
                                scope.row.representantes.length === 1
                            "
                        ></el-descriptions-item>
                        <el-descriptions-item
                            class="has-colon-not"
                            :label="
                                $tc(
                                    'certification.messages.territory_has_no_people'
                                )
                            "
                            v-if="
                                scope.row.representantes &&
                                scope.row.representantes.length === 0
                            "
                        ></el-descriptions-item>
                        <el-descriptions-item
                            class="descricao-item-tabela"
                            :size="'mini'"
                        >
                            <el-descriptions-item
                                label="CAR:"
                                v-if="
                                    scope.row.cars && scope.row.cars.length > 1
                                "
                            >
                                <div class="car-list-row">
                                    <div
                                        class="cars"
                                        v-for="car in scope.row.cars"
                                        :key="car.codigo"
                                    >
                                        <p>{{ car.codigo }}</p>
                                    </div>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item
                                class="has-colon-not"
                                :label="
                                    $tc(
                                        'certification.messages.territory_has_no_additional_cars'
                                    )
                                "
                                v-if="
                                    scope.row.cars &&
                                    scope.row.cars.length === 1
                                "
                            ></el-descriptions-item>
                            <el-descriptions-item
                                class="has-colon-not"
                                :label="
                                    $tc(
                                        'certification.messages.territory_has_no_cars'
                                    )
                                "
                                v-if="
                                    scope.row.cars &&
                                    scope.row.cars.length === 0
                                "
                            ></el-descriptions-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </template>
            </el-table-column>
            <el-table-column
                id="remover-certificacao-nao-enviada"
                type="selection"
                v-if="removendo"
                align="center"
            ></el-table-column>
            <el-table-column
                prop="nome"
                :label="$tc('certification.words.territory')"
                sortable="custom"
            ></el-table-column>
            <el-table-column prop="cars" label="CAR" sortable="custom">
                <template slot-scope="scope">
                    <div
                        v-if="scope.row.cars && scope.row.cars.length > 0"
                        class="car"
                    >
                        <p class="car-hiden-row">
                            {{ formatarCar(scope.row.cars[0].codigo) }}
                        </p>
                        <el-tag
                            v-if="scope.row.cars.length > 1"
                            class="ml-2"
                            size="mini"
                        >
                            + {{ scope.row.cars.length - 1 }}
                        </el-tag>
                    </div>
                    <div v-else class="car">
                        <p>-</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="representantes"
                :label="$tc('certification.messages.people_cpf_cnpj')"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <div
                        v-if="
                            scope.row.representantes &&
                            scope.row.representantes.length > 0
                        "
                        class="representante"
                    >
                        <p>
                            {{ scope.row.representantes[0].nomeRazaoSocial }}
                            <span
                                >({{
                                    formatCpfCnpj(
                                        scope.row.representantes[0]
                                            .cpfCnpjDecrypt
                                    )
                                }})</span
                            >
                            <el-tag
                                v-if="scope.row.representantes.length > 1"
                                class="ml-2"
                                size="mini"
                            >
                                + {{ scope.row.representantes.length - 1 }}
                            </el-tag>
                        </p>
                    </div>
                    <div v-else class="representante">
                        <p>-</p>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="tabela-gestao-contrato-originacao__paginacao">
            <span class="pagina">
                {{ territoriosNaoEnviados.length }}
                {{
                    $tc(
                        'certification.words.territory',
                        territoriosNaoEnviados.length
                    )
                }}
            </span>
            <el-pagination
                background
                :page-size="pageCount"
                :pager-count="pageCount"
                :current-page.sync="paginaAtual"
                layout="prev, pager, next"
                :total="territoriosNaoEnviados.length"
                @current-change="mudarPagina"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import formatters from '@/utils/formatters';

export default {
    name: 'BlocoTabelaNaoEnviadasCertificacao',

    props: {
        territoriosNaoEnviados: {
            type: Array,
            required: true
        },
        removendo: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            territoriosSelecionados: [],
            carregandoTabela: false,
            paginaAtual: 1,
            pageCount: 5
        };
    },

    computed: {
        paginacaoDataTerritoriosNaoEnviados() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.territoriosNaoEnviados.slice(inicio, fim);
        }
    },

    methods: {
        async handleSelectionChange(territorios) {
            this.territoriosSelecionados = territorios;

            var idsTerritorios = this.territoriosSelecionados.map(
                territorio => territorio.id
            );
            this.emiteRemoverTerritorioLote(idsTerritorios);
        },

        emiteRemoverTerritorioLote(idsTerritorios) {
            this.$emit('RemoverTerritorioLote', idsTerritorios);
        },

        formatarCar(car) {
            return formatters.reduzirCar(car);
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        },

        removerTerritorio(territorios) {
            this.carregandoTabela = true;
            territorios.forEach(id => {
                let indice = this.territoriosNaoEnviados.findIndex(
                    obj => obj.id === id
                );
                if (indice !== -1) {
                    this.territoriosNaoEnviados.splice(indice, 1);
                }
            });
            this.paginaAtual = 1;
            setTimeout(() => {
                this.carregandoTabela = false;
            }, 500);
        },

        carregarTabela(valor) {
            this.carregandoTabela = valor;
        },

        sortChangeRequest(column) {
            this.territoriosNaoEnviados.sort((a, b) => {
                let valorA = a[column.prop];
                let valorB = b[column.prop];

                if (column.prop === 'nome') {
                    valorA = valorA.toLowerCase();
                    valorB = valorB.toLowerCase();

                    if (valorA < valorB) {
                        return column.order === 'ascending' ? -1 : 1;
                    }
                    if (valorA > valorB) {
                        return column.order === 'ascending' ? 1 : -1;
                    }
                }
                if (column.prop === 'cars') {
                    if (column.order === 'descending') {
                        return valorA.length - valorB.length;
                    }
                    if (column.order === 'ascending') {
                        return valorB.length - valorA.length;
                    }
                }
                if (column.prop === 'representantes') {
                    if (column.order === 'descending') {
                        return valorA.length - valorB.length;
                    }
                    if (column.order === 'ascending') {
                        return valorB.length - valorA.length;
                    }
                }
                return 0;
            });
            this.paginaAtual = 1;
        },

        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-tabela-territorio-nao-enviado {
    h1,
    .el-checkbox {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        background: transparent;
    }

    .el-checkbox {
        display: block;
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
        .el-table .cell .el-checkbox__inner {
            padding: 0px;
        }
    }
    .el-table__cell {
        font-size: 12px;
    }
    .is-leaf {
        font-size: 13px;
    }

    .el-table .cell {
        word-break: normal;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .el-table td {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid #e9ecef;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }

    .el-checkbox__inner {
        margin-left: -10px;
    }
}
</style>
